import { ArticleModel } from "../archive/article.model";
import { TransferWorkshopStoreModel } from "./transfer-workshop-store.model";

export class TransferWorkshopStoreDetailModel {
  transferWorkshopStoreDetailId: number = 0;
  transferWorkshopStoreId: number = 0;
  transferWorkshopStore: TransferWorkshopStoreModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  storeId: number = 0;
  quantity: number = 0;
  costValue: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}